var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.info.customCode
        ? _c("yxt-input", {
            attrs: { disabled: "", value: _vm.info.customCode },
          })
        : _vm.hasCatalogCode
        ? [
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pc_kng_upload_lbl_customcode_tip1" /** A-a1-年月日-创建数自增 */
                  )
                )
              ),
            ]),
            _c("div", { staticClass: "color-gray-6 standard-size-14" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pc_kng_upload_lbl_customcode_tip2" /** 发布后自动生成完整编号 */
                  )
                )
              ),
            ]),
          ]
        : [
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pc_kng_upload_lbl_customcode_tip3" /** 课程分类未设置编号，无法生成课程编号 */
                  )
                )
              ),
            ]),
            _c("div", { staticClass: "color-gray-6 standard-size-14" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pc_kng_upload_lbl_customcode_tip4" /** 您可以正常发布课程，发布后补充分类编号后会自动生成 */
                  )
                )
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }